




<div class="task-management-container ui-dark-background" data-cy="task-management-dialog-container">
  <div class="section" style="display: flex; flex-direction: column; height: 100%; max-height: 100%;">
    <div class="section-header" style="flex-basis: 30px;" data-cy="task-management-header-section">
      <div class="section-header-title" data-cy="task-management-title-text">
        Task Management
      </div>
      
      <div style="flex: 1;">
        
      </div> 
    </div>
    <mat-progress-bar *ngIf="isLoading" mode="indeterminate" data-cy="task-management-loading-bar"></mat-progress-bar>
    <!--  MAIN AREA-->
    <div class="section-content" style="display: flex; flex-direction: column; flex: 1; margin-top: 12px; overflow: hidden;" data-cy="task-management-content-section">
     
      <div style="display: flex; flex-basis: 60px;  max-height: 80px; background-color: var(--tdo-background); border-top-left-radius: var(--border-radius); border-top-right-radius: var(--border-radius); padding-top: 4px; padding-left: 4px; padding-bottom: 4px;" data-cy="task-management-filter-container">
        <div style="display: flex; flex-basis: fit-content; flex-direction: column; margin-right: 1px; border-right: 2px solid white; padding-right: 3px;" data-cy="task-management-user-section">
          <div style="font-weight: bold;" data-cy="task-management-user-label">User:</div>
          <div data-cy="task-management-user-name">{{getUserFullName()}}</div>
        </div>

        <div style="flex: 2; flex-direction: column; margin-right: 1px; display: flex; padding-right: 4px;" data-cy="task-management-groups-section">
          <div style="font-weight: bold;" data-cy="task-management-groups-label">
            Member of User Groups:
          </div>
          <div style="background-color:white; flex: 1; padding-right: 4px; display: flex; flex-direction: column; font-size: 12px; max-height: 100%; height: 100%; overflow-y: auto; text-align: left; line-height: 1.1;" data-cy="task-management-groups-list">
            <ng-container *ngIf="currentUser">
              <div *ngFor="let inGroup of currentUser.cfgTDOUserInGroups" data-cy="task-management-group-item">
                {{inGroup.cfgTDOUserGroup?.UserGroupName}}
              </div>
            </ng-container>
          </div>
        </div>

        <div style="width: 150px;" data-cy="task-management-task-filter">
          <mat-radio-group class="example-radio-group"   
                [ngModel]="isAllTasks" (ngModelChange)="onShowTasksChange($event)" aria-label="Select an option" data-cy="task-management-tasks-radio">
            <mat-radio-button class="example-radio-button" [value]="false" data-cy="task-management-my-tasks-radio">My Tasks</mat-radio-button>
            <mat-radio-button class="example-radio-button" [value]="true" data-cy="task-management-all-tasks-radio">All Tasks</mat-radio-button>
          </mat-radio-group>
        </div>

        <div style="flex: 1; flex-direction: column;" data-cy="task-management-show-options">
          <mat-checkbox [(ngModel)]="queryModel.isShowCompletedTasks" (ngModelChange)="onShowCompletedChange($event)" data-cy="task-management-completed-checkbox">Completed Tasks</mat-checkbox>
          <mat-checkbox [(ngModel)]="queryModel.isShowSystemTasks" (ngModelChange)="onShowSystemTasksChange($event)" data-cy="task-management-system-checkbox">System Tasks</mat-checkbox>
        </div>

        <div style="flex: 2; margin-right: 1px; display: flex; padding-left: 10px;" data-cy="task-management-date-range">
          <div style="flex-basis: fit-content;" data-cy="task-management-from-label">From:</div>
          <div style="display: flex; flex-direction: column;" data-cy="task-management-date-inputs">
            <div style="display: flex; margin-left: 10px;" data-cy="task-management-start-date-container">
              <div style="max-height: 40px; position: relative; top: -20px;">
                <input style="background-color: white; height: 20px; width: 102px;" (focus)="onStartDateFocus($event)" [readonly]="!queryModel.isShowCompletedTasks && !queryModel.isShowSystemTasks" matInput (dateChange)="onStartDateChange($event)" [(ngModel)]="queryModel.startDate"
                       [matDatepicker]="pickerStart"
                       placeholder="Start Date" data-cy="task-management-start-date-input">
                <mat-datepicker-toggle style="position: relative; top: 10px;" matSuffix [for]="pickerStart" data-cy="task-management-start-date-toggle"></mat-datepicker-toggle>
                <mat-datepicker #pickerStart></mat-datepicker>
              </div>
            </div>
            <div style="display: flex; margin-left: 10px; position: relative; top: -10px;" data-cy="task-management-end-date-container">
              <input style="background-color: white; height: 20px; width: 102px;" [readonly]="!queryModel.isShowCompletedTasks && !queryModel.isShowSystemTasks" matInput (dateChange)="onEndDateChange($event)" [(ngModel)]="queryModel.endDate"
                     [matDatepicker]="pickerEnd"
                     placeholder="End Date" data-cy="task-management-end-date-input">
              <mat-datepicker-toggle [disabled]="!queryModel.isShowCompletedTasks && !queryModel.isShowSystemTasks" style="position: relative; top: -10px;" matSuffix [for]="pickerEnd" data-cy="task-management-end-date-toggle"></mat-datepicker-toggle>
              <mat-datepicker #pickerEnd></mat-datepicker>
            </div>
          </div>
        </div>
        <button mat-raised-button color="primary" (click)="onReload()" data-cy="task-management-reload-button">Reload</button>
      </div>
<!--      TABLE OF TASKS-->
      <div style="flex: 1; display: flex; flex-direction: column; background-color: var(--tdo-background); overflow-y: hidden; margin-top: 1px; border-bottom-left-radius: var(--border-radius); border-bottom-right-radius: var(--border-radius);" data-cy="task-management-table-container">
        <div style="display: flex; flex-basis: fit-content;" data-cy="task-management-add-row">
          <div style="flex: 1;"></div>
          <div matTooltip="Add task" (click)="onAddNewTask()" style="cursor: pointer; color: var(--tdo-primary-accent);" data-cy="task-management-add-button"><mat-icon>add_circle_outline</mat-icon></div>
        </div>
        <div style="flex: 1; overflow: hidden;" data-cy="task-management-table-wrapper">
          <tdo-table *ngIf="tasks" #taskTable [dataSource]="tasks" isSearchable="false" sortDirection="desc" sortActive="DueDate" (tableRenderComplete)="hideLoader()" data-cy="task-management-table">
            <tdo-table-column displayName="Due" propertyName="DueDate" isSortable="true" [rowTemplate]="dueDate" data-cy="task-management-due-column">
              <ng-template #dueDate let-row>
                <div style="max-width: 160px; display: flex; position: relative;" data-cy="task-management-due-cell">
                  <div *ngIf="isPastDue(row.model)" style="color: red; position: absolute; top: 1px; left: -22px;" data-cy="task-management-past-due-icon"><mat-icon>warning_amber</mat-icon></div>
                  <div data-cy="task-management-due-date">{{convertUTCDatetoTimezone(row.model.DueDate, this.TZID) | date:'medium' }}</div>
                </div>
              </ng-template>
            </tdo-table-column>
            <tdo-table-column displayName="Description" propertyName="Description" [rowTemplate]="description" data-cy="task-management-description-column">
              <ng-template #description let-row>
                <div data-cy="task-management-description-cell">{{row.model.Description}}</div>
              </ng-template>
            </tdo-table-column>
            <tdo-table-column displayName="Type" propertyName="enumUserTaskTypeID" [rowTemplate]="taskType" data-cy="task-management-type-column">
              <ng-template #taskType let-row>
                <div data-cy="task-management-type-cell">{{getUserTaskType(row.model.enumUserTaskTypeID)}}</div>
              </ng-template>
            </tdo-table-column>
            <tdo-table-column displayName="For" propertyName="aa" [rowTemplate]="forWhom" data-cy="task-management-for-column">
              <ng-template #forWhom let-row>
                <div data-cy="task-management-for-cell">{{getFor(row.model)}}</div>
              </ng-template>
            </tdo-table-column>
            <tdo-table-column displayName="Assigned" propertyName="AssignedToUserID" [rowTemplate]="assignedTo" data-cy="task-management-assigned-column">
              <ng-template #assignedTo let-row>
                <div style="height: 36px; overflow-y: hidden; margin-top: 5px;" data-cy="task-management-assigned-cell">
                  <app-tdo-dropdown width="120"
                                    [dataSource]="users"
                                    [isObjectValue]="true"
                                    [value]="getUserAssigned(row.model.AssignedToUserID)" dataSourceDisplayKey="UserName" placeholder="Select User"
                                    (selectionChange)="onAssignedUserChange($event, row)" data-cy="task-management-assigned-dropdown"></app-tdo-dropdown>
                </div>
              </ng-template>
            </tdo-table-column>
            <tdo-table-column displayName="Priority" propertyName="enumTaskPriorityID" [rowTemplate]="priority" data-cy="task-management-priority-column">
              <ng-template #priority let-row>
                <div data-cy="task-management-priority-cell">{{getPriority(row.model.enumTaskPriorityID)}}</div>
              </ng-template>
            </tdo-table-column>
            <tdo-table-column displayName="Status" propertyName="enumTaskStatusID" [rowTemplate]="status" data-cy="task-management-status-column">
              <ng-template #status let-row>
                <div style="height: 36px; overflow-y: hidden; margin-top: 5px;" data-cy="task-management-status-cell">
                  <app-tdo-dropdown width="120" 
                                    [dataSource]="taskStatusEnums" 
                                    [isObjectValue]="true"
                                    [value]="getTaskStatus(row.model.enumTaskStatusID)" dataSourceDisplayKey="ItemDisplayValue" placeholder="Select" 
                                    (selectionChange)="onTaskStatusChange($event, row)" data-cy="task-management-status-dropdown"></app-tdo-dropdown>
                </div>
              </ng-template>
            </tdo-table-column>
            <tdo-table-column displayName="Date" propertyName="xauditModifiedOn" [rowTemplate]="date" data-cy="task-management-date-column">
              <ng-template #date let-row>
                <div data-cy="task-management-date-cell">*</div>
              </ng-template>
            </tdo-table-column>
            <tdo-table-column displayName="" propertyName="openTaskDetails" [rowTemplate]="taskDetails" data-cy="task-management-details-column">
              <ng-template #taskDetails let-row>
                <div matTooltip="Update task details" (click)="openTaskDetails(row.model)" style="position: relative; top: 2px; cursor: pointer; color: var(--tdo-secondary)" data-cy="task-management-details-button"><mat-icon>assignment</mat-icon></div>
              </ng-template>
            </tdo-table-column>
          </tdo-table>
        </div>
      </div>
    </div>
    <!--  FOOTER-->
    <div class="section-footer" style="flex-basis: 60px; padding-top: 6px;" data-cy="task-management-footer-section">
      <div style="flex: 1; margin-right: 6px;"></div>
      <button (click)="onCancelClick()" class="tdo-button tdo-close" style="margin-right: 6px;" data-cy="task-management-cancel-button">Cancel</button>
      <button (click)="onOkClick()" class="tdo-button tdo-save" style="margin-right: 6px;" data-cy="task-management-ok-button">Ok</button>
    </div>
  </div>
</div>
